import * as React from 'react';
import {Icon, AppLogo} from '@openfin/desktop-ui';

import * as HandleImage from '../../../assets/Handle.svg';
import {ClassNameBuilder} from '../../utils/ClassNameBuilder';

import * as Styles from './ChannelAppInfo.module.scss';

interface Props {
    header?: boolean;
    appName: string;
    appIcon?: string;
    appTitle: string;
}

export const ChannelAppInfo: React.FC<Props> = (props) => {
    const {header, appName, appIcon, appTitle} = props;
    const classNames = new ClassNameBuilder(Styles, 'channel-app-info', ['header', !!header]);

    return (
        <div className={classNames.toString()}>
            <div className={Styles['handle']}>
                {!header && <Icon className={Styles['handle-icon']} src={HandleImage}></Icon>}
            </div>
            <div className={Styles['application']}>
                {appIcon && <AppLogo className={Styles['member-icon']} src={appIcon} />}
                <span>{appName}</span>
            </div>
            <div className={Styles['title']}><span>{appTitle}</span></div>
        </div>
    );
};
